module.exports = __webpack_public_path__ + "assets/img/lector-22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/lector-22.png
// module id = 1959
// module chunks = 0